import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { PutScrapFinanceAccountsService } from "@/features/accounts/scrap-finance/services/put-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { usePutScrapFinanceAccountStates } from "@/features/accounts/scrap-finance/hooks/use-put-accounts-states";
import { useContext } from "react";


export const usePutScrapFinanceAccount = () => {
  const {
    scrapFinanceAccountId,
    setScrapFinanceAccountId,
    scrapFinanceId,
    setScrapFinanceId,
    isShowErrorDialog,
    setIsShowErrorDialog,
  } = usePutScrapFinanceAccountStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const putScrapFinanceAccountsService = new PutScrapFinanceAccountsService();

  /*--------------------
    イベント関連
  --------------------*/
  // 金融機関更新
  const updateScrapFinanceAccounts = async (
    accountGroupId: string,
    scrapFinanceAccountId: string,
    scrapFinanceId: string,
    passbookName?: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await putScrapFinanceAccountsService.putScrapFinanceAccounts({
        account_group_id: accountGroupId,
        scrap_finance_account_id: scrapFinanceAccountId,
        scrap_finance_id: scrapFinanceId,
        ...(passbookName !== undefined && { passbook_name: passbookName }),

      });
      // 成功時の処理
    } catch (error) {
      // エラーハンドリング
      console.log("updateFinanceAccounts:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    scrapFinanceAccountId,
    setScrapFinanceAccountId,
    scrapFinanceId,
    setScrapFinanceId,
    isShowErrorDialog,
    setIsShowErrorDialog,
    updateScrapFinanceAccounts: errorHandledAsync(updateScrapFinanceAccounts, setError),
  };
};
